import { esAmazonas } from './states/amazonas';
import { esAnzoategui } from './states/anzoategui';
import { esApure } from './states/apure';
import { esAragua } from './states/aragua';
import { esBarinas } from './states/barinas';
import { esBolivar } from './states/bolivar';
import { esCarabobo } from './states/carabobo';
import { esCojedes } from './states/cojedes';
import { esDeltaAmacuro } from './states/deltaAmacuro';
import { esDistrito } from './states/distritoCapital';
import { esFalcon } from './states/falcon';
import { esGuarico } from './states/guarico';
import { esLara } from './states/lara';
import { esMerida } from './states/merida';
import { esMiranda } from './states/miranda';
import { esMonagas } from './states/monagas';
import { esNuevaEsparta } from './states/nuevaEsparta';
import { esPortuguesa } from './states/portuguesa';
import { esSucre } from './states/sucre';
import { esTachira } from './states/tachira';
import { esTrujillo } from './states/trujillo';
import { esVargas } from './states/vargas';
import { esYaracuy } from './states/yaracuy';
import { esZulia } from './states/zulia';

export const Regions = [
  'ACRM Aragua',
  'ACRM Capital 1',
  'ACRM Capital 2',
  'ACRM Capital 3',
  'ACRM Capital 4',
  'ACRM Capital 5',
  'ACRM Carabobo.',
  'ACRM centro occidente (del país). ',
  'ACRM Región los andes.',
  'ACRM Occidente.',
  'ACRM Oriente (centro, norte, sur).',
];

export const TypePerson = ['Juridica', 'Natural'];

export const levelSEconNatu = ['A+', 'A', 'B', 'C+', 'C', 'D', 'E'];

export const levelSEconJur = [
  'Corporativo',
  'Empresas',
  'Pymes II',
  'Pymes I',
  'Comercios',
  'Firmas Personales',
  'Sector Institucional Público',
  'Corporaciones Públicas',
  'Oficias de Gobierno',
  'Entes Descentralizados',
];

export const RiskTypes = [
  'Organizaciones sin fines de lucro (OSFL).',
  'Personas políticamente expuestas (PPE).',
  'Banca privada.',
  'Proveedores: Prestadores de servicio al Banco de Venezuela.',
  'Supervisores: Lista de casos que han sido asignados a supervisores del área debido a escalamiento y/o circunstancias de trato especial.',
  'Director: Clasificación para los altos ejecutivos del banco. • Empleados BDV: Corresponde a empleados del Banco de Venezuela.',
  'Corporativa.',
  'Emprendedores.',
  'Banca de empresa.',
  'Especialista cumplimiento: utilizada en caso de que el cliente no tenga una clasificación adecuada proveniente de la oficina donde realizo el registro. • Institucional moneda extranjera (I).',
  'Institucional moneda extranjera (persona natural).',
  'Institucional moneda extranjera (activos virtuales): Hace referencia a criptomonedas y dinero virtual.',
];

/* RISKS */

enum RiksTexts {
  low = 'Riesgo Bajo',
  medium = 'Riesgo Moderado',
  high = 'Riesgo Alto',
}

enum RiksLevels {
  low = 'low',
  medium = 'medium',
  high = 'high',
}

enum RiskColors {
  low = 'Amarillo',
  medium = 'Mostaza',
  high = 'Rojo',
}
interface riskLevel {
  color: RiskColors;
  value: RiksLevels;
  name: RiksTexts;
}

export const riskLevels: riskLevel[] = [
  {
    color: RiskColors.low,
    value: RiksLevels.low,
    name: RiksTexts.low,
  },
  {
    color: RiskColors.medium,
    value: RiksLevels.medium,
    name: RiksTexts.medium,
  },
  {
    color: RiskColors.high,
    value: RiksLevels.high,
    name: RiksTexts.high,
  },
];

export const Estados = [
  {
    estado: 'Distrito Capital',
    municipio: esDistrito,
  },
  {
    estado: 'Amazonas',
    municipio: esAmazonas,
  },
  {
    estado: 'Anzoátegui',
    municipio: esAnzoategui,
  },
  {
    estado: 'Apure',
    municipio: esApure,
  },
  {
    estado: 'Aragua',
    municipio: esAragua,
  },
  {
    estado: 'Barinas',
    municipio: esBarinas,
  },
  {
    estado: 'Bolívar',
    municipio: esBolivar,
  },
  {
    estado: 'Carabobo',
    municipio: esCarabobo,
  },
  {
    estado: 'Cojedes',
    municipio: esCojedes,
  },
  {
    estado: 'Delta Amacuro',
    municipio: esDeltaAmacuro,
  },
  {
    estado: 'Falcón',
    municipio: esFalcon,
  },
  {
    estado: 'Guárico',
    municipio: esGuarico,
  },
  {
    estado: 'Lara',
    municipio: esLara,
  },
  {
    estado: 'Mérida',
    municipio: esMerida,
  },
  {
    estado: 'Miranda',
    municipio: esMiranda,
  },
  {
    estado: 'Monagas',
    municipio: esMonagas,
  },
  {
    estado: 'Nueva Esparta',
    municipio: esNuevaEsparta,
  },
  {
    estado: 'Portuguesa',
    municipio: esPortuguesa,
  },
  {
    estado: 'Sucre',
    municipio: esSucre,
  },
  {
    estado: 'Táchira',
    municipio: esTachira,
  },
  {
    estado: 'Trujillo',
    municipio: esTrujillo,
  },
  {
    estado: 'Vargas',
    municipio: esVargas,
  },
  {
    estado: 'Yaracuy',
    municipio: esYaracuy,
  },
  {
    estado: 'Zulia',
    municipio: esZulia,
  },
];
//Sucursales
export const sucursales = [
  'Zaraza',
  'Turmero',
  'Villa De Cura',
  'Las Delicias C.F. Banvenez',
  'San Casimiro',
  'Cagua Calle Sucre',
  'Las Tejerías',
  'Kellogg´s',
  'Sucursal Maracay',
  'El Sombrero',
  'Maracay Plaza',
  'Calabozo Carrera 13',
  'Gobernación de Aragua',
  'La Victoria Av. Victoria',
  'El Limón',
  'Maracay Principal',
  'La Morita 2',
  'Palo Negro',
  'Altagracia de Orituco',
  'Puerto Ayacucho',
  'San Fernando de Apure',
  'San Juan de Los Morros Av. Bolívar',
  'Valle de La Pascua Av. Rómulo Gallegos',
  'Calabozo Carrera 05',
  'San Fernando de Apure Av. Miranda',
  'Mercedes del Llano',
  'Maracay Edif. Don Juan',
  'San Juan de Los Morros Villa Olimpica',
  'Las Mercedes Av. Principal',
  'Altamira',
  'Los Palos Grandes C.C. Plaza',
  'Macaracuay',
  'C.C.C.T. Nivel C-2',
  'La Trinidad Urb. Sorocaima',
  'La Castellana Av. Mohedano',
  'Vizcaya',
  'La Boyera',
  'Sambil Nivel Acuario',
  'Plaza Las Américas',
  'Plaza La Castellana',
  'El Rosal Av. Guaicaipuro',
  'San Ignacio',
  'Chacao Av. Loyola',
  'Chuao Santa Marta',
  'Prados Del Este',
  'Las Mercedes C.C. Tolón',
  'La Pirámide',
  'Guatire 9 de Diciembre',
  'Unicentro El Marques',
  'Higuerote',
  'Los Ruices. Centro Empresarial.',
  'Parque Ávila',
  'La California Torre Profesional',
  'La Urbina C.C. Los Jardines',
  'Sucursal La Carlota',
  'El Marques Av. Rómulo Gallegos',
  'Río Chico',
  'Guarenas Calle Páez',
  'C.C. Millenium Mall',
  'Los Cortijos',
  'Guatire Calle Sucre ',
  'PAB SUDEBAN',
  'Guatire C.C. Buenaventura',
  'Guarenas C.C. Miranda ',
  'El Paraíso Av. República',
  'Propatria',
  'Catia La Mar Av. Atlántida',
  'Caricuao',
  'Av. Soublette',
  'Vista Alegre',
  'Montalbán',
  'La Yaguara',
  'Caraballeda',
  'San Martin Toritos',
  'Pérez Bonalde',
  'Catia Av. Sucre',
  'Plaza Miranda',
  'Colonia Tovar',
  'Quinta Crespo Esq. El Carmen',
  'Maiquetía',
  'Sucursal Centro',
  'Terminal La Zorra',
  'Asamblea Nacional',
  'PAB PLC (Puertos Del Litoral Central)',
  'Ciudad Caribia ',
  'Catia La Haud ',
  'Catia - Plaza Pérez Bonalde ',
  'Vargas - Casa Guipuzcoana',
  'Los Roques ',
  'El Valle',
  'San Bernardino Av. Cajigal',
  'Colinas De Bello Monte',
  'Las Palmas',
  'Av. Presidente Medina',
  'Los Chaguaramos',
  'La Florida',
  'Centro Lido',
  'Seniat Plaza Venezuela',
  'Residencias Fuerte Tiuna',
  'Sucursal Bello Monte',
  'El Recreo',
  'La Previsora',
  'Santa Mónica Teresa De La Parra',
  'Santa Mónica Av. Lazo Martí',
  'Av. Roosevelt',
  'Ipsfa',
  'Cantv Av. Libertador',
  'Zona Rental Abasto Bicentenario',
  'PDVSA La Campiña',
  'Comandancia General De La Armada',
  'Edif. Las Fundaciones',
  'San Antonio De Los Altos',
  'Cúa',
  'El Tambor',
  'Santa Teresa del Tuy Calle Sucre',
  'Charallave Av. Bolívar',
  'Urdaneta Esq. Veroes',
  'Puente Mohedano',
  'Los Teques Av. La Hoyada',
  'Santa Teresa Del Tuy Negro Primero',
  'Los Castores',
  'Los Teques Av. Independencia',
  'Cuartel Viejo',
  'Ocumare del Tuy',
  'Prado de María',
  'Los Jabillos Sur',
  'San José',
  'Av. Urdaneta',
  'Santa Lucia',
  'La Casona',
  'Taquilla La Cascada ',
  'PAB Guardia de Honor Palacio de Miraflores ',
  'Ministerio de Finanzas',
  'Plaza Bicentenaria del Palacio de Miraflores ',
  'San Francisco de Yare',
  'Av Bolívar (Valencia)',
  'Guacara',
  'Naguanagua',
  'Tinaquillo',
  'Sucursal Valencia',
  'Refinería El Palito',
  'Valencia Zona Industrial',
  'Puerto Cabello Calle Colón',
  'El Viñedo',
  'San Carlos Edif. Los Ruices',
  'Valencia Centro',
  'Mariara',
  'Bejuma',
  'Michelena',
  'Naguanagua C.C. Cristal',
  'Tucacas',
  'Gobernación De Cojedes',
  'San Carlos Av. Bolívar',
  'Valencia C.C. Metrópolis ',
  'Quíbor',
  'Barquisimeto Calle 42',
  'Sabaneta',
  'Araure',
  'Sucursal Barquisimeto',
  'Chivacoa',
  'Zona Industrial Iii (Barquisimeto)',
  'Nirgua',
  'Barquisimeto Av . Vargas',
  'Guanarito',
  'Libertad De Barinas',
  'Acarigua Av. Libertador',
  'Barinas Cruce Con Calle Plaza',
  'El Tocuyo',
  'Guanare',
  'San Felipe Av. Libertador',
  'Carora Av. Francisco De Miranda',
  'Turen',
  'Barquisimeto Av Lara',
  'Barquisimeto C.C Ven-Rol',
  'Cima Barinas',
  'C.C. Los Jardines',
  'Cemex Barquisimeto',
  'Guanare Edif. San Juan',
  'Acarigua Llano Mall',
  'San Felipe Av. Carabobo',
  'Cabudare',
  'Barquisimeto C.C. Sambil',
  'Barquisimeto Paseo Los Leones',
  'La Concordia',
  'San Juan De Colón',
  'Sambil San Cristóbal',
  'Pirineos',
  'Las Tapias',
  'Socopó',
  'Guasdualito',
  'La Grita',
  'Santa Bárbara De Barinas',
  'Sucursal San Cristóbal',
  'Las Tienditas ',
  'El Vigía Av. Bolívar',
  'Mérida Calle 23',
  'San Antonio Del Táchira Carrera 9',
  'Rubio',
  'Mérida Calle 21',
  'Santa Bárbara Del Zulia',
  'San Cristóbal - El Tamá',
  'San Cristóbal Pasaje Acueducto',
  'Mérida C.C. Millenium',
  'Tovar',
  'Glorias Patrias',
  'La Fría',
  'Mérida Av. Las Américas',
  'Boconó',
  'Bella Vista',
  'La Limpia',
  'Sucursal Maracaibo',
  'Villa Del Rosario',
  'Los Haticos',
  'Machiques',
  '5 De Julio',
  'Coro Pasaje Talavera',
  'Cabimas Av. Independencia',
  'Zona Industrial Maracaibo',
  'Judibana',
  'Punto Fijo Av. Bolívar',
  'Trujillo',
  'Valera Av. 10',
  'Ciudad Ojeda',
  'Refinería Amuay ',
  'Maracaibo 80',
  'Cabimas Av. Principal',
  'Pampan',
  'Valera C.C. Pineda',
  'C.C Sambil Maracaibo',
  'Cemex Maracaibo',
  'Sabana De Mendoza',
  'Sucursal Dr. Portillo',
  'Coro Ramón Antonio Medina',
  'Dabajuro',
  'Punto Fijo C.C. Sambil ',
  'Maracaibo Lago Mall',
  'Maracaibo Cecilio Acosta',
  'Puerto Cumarebo',
  'Centro Refinación Paraguaná',
  'Irapa',
  'El Furrial',
  'Caripito',
  'Carúpano',
  'Güiria',
  'Maturín Edif. Banvenez',
  'Río Caribe',
  'Quiriquire',
  'Aguasay',
  'San Antonio Edif. Rental',
  'Caicara ',
  'Cariaco Centro ',
  'Yaguaraparo',
  'Caripe Edf. Montesanti',
  'Temblador',
  'Juncal Edif. Centro Profesionales',
  'Principal Av. Juncal',
  'Campo Claro',
  'Centro Comercial Petroriente C.C.P',
  'Los Guaritos',
  'Punta De Mata Ii ',
  'P.D.V.S.A',
  'Carúpano Centro',
  'Carúpano  Mercado ',
  'Taquilla El Pilar',
  'Pdvsa Cv Maturín',
  'Uracoa',
  '4 De Mayo',
  'Barcelona Calle Bolívar',
  'Suc. Puerto La Cruz',
  'Porlamar Bulevar Guevara',
  'Porlamar C/Fraternidad',
  'Pto. La Cruz Av. Municipal',
  'Sambil Margarita',
  'Conejeros',
  'Barcelona Av. 5 De Julio',
  '5 De Julio Av. Los Ángeles',
  'Barcelona Country',
  'Jorge Coll',
  'La Asunción ',
  'Juan Griego',
  'Gobernación Nueva Esparta',
  'Puerto Píritu',
  'El Morro',
  'Aragua De Barcelona',
  'Anaco Calle Bolívar',
  'Cumaná Calle Mariño',
  'Cantaura',
  'Cumaná Av. Gran Mariscal',
  'Cumanacoa',
  'Araya',
  'Marigüitar',
  'Santa Ana',
  'Sucursal Cumaná',
  'Gran Avenida',
  'El Bosque Av. Carúpano',
  'Bahía Pozuelos',
  'Caicara del Orinoco',
  'Upata Calle Sucre',
  'El Tigrito',
  'Ciudad Bolívar Paseo Orinoco',
  'Puerto Ordaz Edif. Banvenez',
  'Altavista',
  'El Callao',
  'El Tigre Av. Francisco de Miranda',
  'Tucupita',
  'San Félix Calle 2',
  'El Tigre Av. España',
  'PAB Canaima',
  'Barrancas',
  'Tucupita Av. Monseñor Argimiro',
  'Sucursal Puerto Ordaz',
  'Unare',
  'Los Olivos',
  'Pariaguán',
  'San José de Guanipa',
  'Santa Elena de Uairén',
  'Bauxilum Los Pijiguaos',
  'Taquilla Orinoco Iron',
  'Ferrominera Orinoco',
  'Sidor',
  'CVG Bauxilum',
];

export const occupation = [
  'ACTOR, ARTISTA',
  'ADMINISTRADOR',
  'AGENTE DE SEGURIDAD  VIGILANTE  ESCOLTA',
  'AGENTE VIAJERO',
  'AGRICULTOR  CULTIVADOR  GANADERO  AVICULTOR  SILVICULTOR',
  'ALBAÑIL',
  'ALGUACIL',
  'AMA DE CASA',
  'AMA DE LLAVES  MAYORDOMO  DOMESTICA',
  'ANALISTA DE OFICINA',
  'ANIMADOR',
  'ANTICUARIO  COLECCIONISTA',
  'ANTROPOLOGIA, SOCIOLOGIA Y TRABAJO SOCIAL',
  'ARBITRO DEPORTIVO',
  'ARCHIVISTA',
  'ARCHIVOLOGIA Y BIBLIOTECOLOGIA',
  'ARQUITECTURA AERONAUTICA Y CIENCIAS NAOTICAS',
  'ARQUITECTURA Y URBANISMO',
  'ARTES Y MUSICA',
  'ARTES, LETRAS Y SIMILARES',
  'ARTESANO',
  'ARTISTA',
  'ARTISTA DE CIRCO',
  'ASCENSORISTA',
  'ASEADOR',
  'ASERRADOR',
  'ASESOR  CONSULTOR',
  'ASISTENTE',
  'AZAFATA  ASISTENTE DE ABORDO',
  'BAILARIN',
  'BARBERO',
  'BARMAN',
  'BIBLIOTECARIOS',
  'BIOANALISIS',
  'BIOLOGIA',
  'BIOLOGIA MARINA Y CIENCIAS APLICADAS AL MAR',
  'BOMBERO',
  'BUZO',
  'CADDY',
  'CAJERO',
  'CALETERO',
  'CAMARERO',
  'Camarógrafo',
  'CAMBISTA',
  'CAMILLERO',
  'CANTANTE',
  'CANTINERO',
  'CARPINTERO',
  'CARTERO',
  'CARTOGRAFO',
  'CATADOR',
  'CAUCHERO',
  'CAZADOR',
  'CERRAJERO',
  'CIENCIAS ADMINISTRATIVAS GERENCIALES',
  'CIENCIAS ADMINISTRATIVAS Y FINANCIERAS FISCALES Y RENTAS',
  'CIENCIAS BASICAS',
  'CIENCIAS DE LA SALUD',
  'CIENCIAS DEL AGRO Y DEL MAR, RECURSOS NATURALES',
  'CIENCIAS FISCALES Y FINANCIERAS',
  'CIENCIAS MECANICAS, ELECTRICA Y ELECTRONICAS',
  'CIENCIAS NAVALES',
  'CIENCIAS POLICIALES',
  'CIENCIAS SOCIALES Y SIMILARES',
  'CIENCIAS Y ARTES MILITARES',
  'COBRADOR',
  'COCINERO  CHEF',
  'COMERCIANTE DE CHATARRA Y METALES',
  'COMERCIANTE INDEPENDIENTE (BUHONERO, COMISIONISTA, VENDEDOR AMBULANTE, COMERCIANTE)',
  'COMPOSITOR',
  'COMPUTISTA  PROGRAMADOR',
  'COMUNICACION SOCIAL',
  'CONDUCTOR (CHOFER, TAXISTA, GANDOLERO)',
  'CONSERJE',
  'CONSTRUCCION Y DISEÑO DE OBRAS CIVILES',
  'CONSTRUCTOR',
  'CONTABLE',
  'CONTADURIA',
  'CONTRATISTA',
  'COREAGRAFO',
  'CORREDOR',
  'CORREDOR DE SEGUROS',
  'COSMETOLOGO',
  'COSTURERO',
  'CREATIVO',
  'CRISTALERO',
  'CUIDADOR  NIÑERO',
  'DECORADOR',
  'DEPORTISTA (ATLETA)',
  'DERECHO',
  'DESEMPLEADO',
  'DETECTIVE  INVESTIGADOR',
  'DIBUJANTE',
  'DIRECTOR',
  'DISEÑADOR',
  'DISKJOCKEY',
  'DOCENTE (PROFESOR  MAESTRO)',
  'EBANISTA',
  'ECONOMIA',
  'EDUCACION AGROPECUARIA',
  'EDUCACION EN CASTELLANO Y LITERATURA, IDIOMAS Y LENGUAS EXTRANJERAS',
  'EDUCACION EN CIENCIAS BASICAS',
  'EDUCACION EN CIENCIAS SOCIALES',
  'EDUCACION ESPECIAL',
  'EDUCACION FISICA',
  'EDUCACION PEDAGOGICA Y PREESCOLAR',
  'EDUCACION TECNICA INDUSTRIAL Y COMERCIAL',
  'EDUCACION Y PEDAGOGIA',
  'ELECTRICISTA',
  'EMPLEADO DE OFICINA O NEGOCIO',
  'ENCUESTADOR',
  'ENFERMERIA',
  'ENFERMERO',
  'ENTRENADOR DEPORTIVO',
  'ESCENOGRAFO',
  'ESCRITOR',
  'ESCULTOR  TALLADOR',
  'ESOTERICO  BRUJO  VIDENTE  ASTROLOGO  ESPIRITISTA',
  'ESTADISTICA Y CIENCIAS ACTUARIALES',
  'ESTILISTA',
  'ESTUDIANTE',
  'ESTUDIOS INTERNACIONALES',
  'ESTUDIOS POLITICOS',
  'EXPLORACION Y EXPLOTACION DE MINAS, PETROLEO E HIDROCARBUROS',
  'EXPLOSIVISTA',
  'FARMACIA',
  'FILOSOFIA Y TEOLOGIA',
  'FISCAL DE TRANSITO',
  'FISICA',
  'FLORISTERO',
  'FOTOGRAFO',
  'FUMIGADOR',
  'FUNCIONARIO EXTRANJERO (EMBAJADA, CONSULADO)',
  'FUNCIONARIO PUBLICO',
  'FUNCIONARIO PUBLICO DE ELECCION POPULAR',
  'GEOGRAFIA',
  'GERENTE',
  'GESTOR',
  'JUBILADO  PENSIONADO',
  'LABORATORISTA (TECNICO)',
  'LAVANDERO  LIMPIADOR  PLANCHADOR',
  'LEÑADOR',
  'LETRAS',
  'LICORERO  BODEGUERO  LUNCHERO',
  'LIMOSNERO',
  'LIMPIABOTAS',
  'LOCUTOR DE RADIO , TV',
  'LOQUERO',
  'LOTERO',
  'MALETERO',
  'MANICURISTA',
  'MAQUINISTA DE AVION  DE NAVEGACION',
  'MASAJISTA',
  'MATEMATICA',
  'MAYORDOMO',
  'MECANICO  LATONERO  PINTOR DE VEHICULO',
  'MECANOGRAFO  ESCRIBIENTE  TRANSCRIPTOR',
  'MEDICINA VETERINARIA',
  'MEDICINA Y PSIQUIATRIA',
  'MENSAJERO',
  'MERCADOTECNIA, PUBLICIDAD Y TURISMO',
  'MESONERO',
  'MILITAR',
  'MINERO',
  'MINERO  CANTERO',
  'MODELO',
  'MOTORIZADO',
  'MUSICO',
  'NUTRICION Y DIETETICA',
  'OBRERO',
  'ODONTOLOGIA',
  'OFICINISTA',
  'OPERADOR DE EQUIPOS Y MAQUINAS',
  'PANADERO  PASTELERO  CARNICERO  QUESERO',
  'PARAMEDICO',
  'PARQUERO',
  'PASANTE',
  'PEDICURISTA',
  'PELUQUERO',
  'PERITO  VALUADOR',
  'PESCADOR',
  'PILOTO DE AVION  NAVEGACION  VEHICULO',
  'PINTOR',
  'PLOMERO',
  'POLICIA',
  'POLITICO',
  'PORTERO',
  'PREPARADOR DE PAPEL',
  'PRESIDENTE (EMPRESA, CLUB, ORGANIZACION)',
  'PRESTAMISTA',
  'PRODUCTOR (TEATRO, CINE, RADIO O TV)',
  'PSICOLOGIA',
  'PUBLICISTA',
  'QUIMICA',
  'RECEPCIONISTA',
  'RECREADOR',
  'RECTOR  VICERECTOR  DECANO',
  'RELACIONES INDUSTRIALES',
  'RELOJERO',
  'SACERDOTE  RELIGIOSO  MONJA  PASTOR',
  'SALVAVIDAS  RESCATISTA',
  'SASTRE',
  'SECRETARIA',
  'SINDICALISTA',
  'SOLDADOR',
  'SUBASTADOR  TASADOR',
  'SUPERVISOR  COORDINADOR',
  'TABAQUERO  CIGARRERO',
  'TALLADOR',
  'TAPICERO',
  'TAQUIGRAFO  MECANOGRAFO',
  'TECNICO DE EQUIPOS ELECTRICOS  ELECTRONICOS  COMPUTACION  MECANICO',
  'TECNICO DE LAS CIENCIAS MEDICAS',
  'TECNICO DE MINAS',
  'TECNICO DE SONIDO',
  'TECNICO EN CIENCIAS BIOLOGICAS Y AGRONOMICAS',
  'TECNICO EN CIENCIAS FISICAS Y QUIMICAS',
  'TECNICO MECANICO  METALURGICO',
  'TELEFONISTA',
  'TELEGRAFISTA',
  'TINTORERO',
  'TIPOGRAFO',
  'TOPOGRAFO',
  'TRABAJADOR SEXUAL',
  'TRADUCTOR',
  'TURISMO',
  'VENDEDOR  PROMOTOR',
  'VENDEDOR DE BIENES RAICES',
  'VISITADOR MEDICO',
  'ZAPATERO',
  'ZOOTECNIA',
];

export const economicActivity = [
  'ACTIVIDADES DE  APOYO A LA EXPLOTACION DE MINAS',
  'ACTIVIDADES DE IMPRESION Y REPRODUCCION DE GRABACIONES',
  'ACTIVIDADES DE LA TECNOLOGIA DE INFORMACION Y DEL SERVICIO INFORMATIVO',
  'ACTIVIDADES DE OFICINAS CENTRALES (SOCIEDADES DE CARTERAS), ACTIVIDADES DE ADMINISTRACION DE EMPRESAS Y DE CONSULTORIA SOBRE ADMINISTRACION DE EMPRESAS',
  'ACTIVIDADES DE PRODUCCION DE PELICULAS, DE VIDEO DE PROGRAMAS DE TELEVISION, GRABACION Y PUBLICACION DE MUSICA Y SONIDO',
  'ACTIVIDADES DE PUBLICACION',
  'ACTIVIDADES DE SANEAMIENTO Y OTROS SERVICIOS DE GESTION DE DESECHOS',
  'ACTIVIDADES DEL SERVICIO INFORMATIVO',
  'ACTIVIDADES ESPECIALIZADAS DE LA CONSTRUCCION',
  'ACTIVIDADES INMOBILIARIAS',
  'ACTIVIDADES JURIDICAS Y DE CONTABILIDAD',
  'AGRICULTURA, GANADERIA, CAZA Y ACTIVIDADES DE SERVICIO CONEXAS',
  'ALCANTARILLADO',
  'ALOJAMIENTO',
  'CAPTACION, TRATAMIENTO Y SUMINISTRO DE AGUA',
  'COMERCIO AL POR MAYOR Y AL POR MENOR REPARACION DE VEHICULOS AUTOMOTORES Y MOTOCICLETAS',
  'COMERCIO AL POR MAYOR, EXCEPTO DE LOS VEHICULOS DE MOTOR Y LAS MOTOCICLETAS',
  'COMERCIO AL POR MENOR, EXCEPTO EL COMERCIO DE VEHICULOS AUTOMOTORES  Y MOTOCICLETAS',
  'CONSTRUCCION DE EDIFICIOS',
  'CORREO Y SERVICIOS DE MENSAJERIA',
  'DEPOSITO Y ACTIVIDADES DE TRANSPORTE COMPLEMENTARIAS',
  'DIFUSION Y PROGRAMACION',
  'ELABORACION DE BEBIDAS',
  'ELABORACION DE PRODUCTOS ALIMENTICIOS',
  'ELABORACION DE PRODUCTOS DE TABACO',
  'EXPLOTACION DE OTRAS MINAS Y CANTERAS',
  'EXTRACCION DE CARBON Y LIGNITO, EXTRACCION DE TURBA',
  'EXTRACCION DE MINERALES METALIFEROS',
  'EXTRACCION DE PETROLEO CRUDO Y GAS NATURAL',
  'FABRICACION  DE COQUE Y DE  PRODUCTOS DE LA  REFINACION  DEL PETROLEO',
  'FABRICACION DE  PRODUCTOS DE CAUCHO Y  PLASTICO',
  'FABRICACION DE  PRODUCTOS DERIVADOS DEL METAL, EXCEPTO  MAQUINARIA YEQUIPO',
  'FABRICACION DE CUEROS Y PRODUCTOS CONEXOS',
  'FABRICACION DE EQUIPO ELECTRICO',
  'FABRICACION DE LA MAQUINARIA Y  EQUIPO N C P',
  'FABRICACION DE LOS PRODUCTOS INFORMATICOS, ELECTRONICOS Y OPTICOS',
  'FABRICACION DE METALES COMUNES',
  'FABRICACION DE MUEBLES',
  'FABRICACION DE OTROS PRODUCTOS MINERALES NO METALICOS',
  'FABRICACION DE OTROS TIPOS DE EQUIPO DE TRANSPORTE',
  'FABRICACION DE PAPEL Y DE LOS PRODUCTOS DE PAPEL',
  'FABRICACION DE PRENDAS DE VESTIR',
  'FABRICACION DE PRODUCTOS FARMACEUTICOS, SUSTANCIAS QUIMICAS MEDICINALES Y DE PRODUCTOS BOTANICOS',
  'FABRICACION DE PRODUCTOS TEXTILES',
  'FABRICACION DE SUSTANCIAS Y  PRODUCTOS QUIMICOS',
  'FABRICACION DE VEHICULOS AUTOMOTORES, REMOLQUES Y SEMIRREMOLQUES',
  'INGENIERIA CIVIL',
  'OTRAS ACTIVIDADES FINACIERAS',
  'OTRAS INDUSTRIAS MANUFACTURERAS',
  'PESCA Y ACUICULTURA',
  'PRODUCCION DE MADERA Y FABRICACION DE PRODUCTOS DE MADERA Y CORCHO, EXCEPTO MUEBLES FABRICACION DE ARTICULOS DE PAJA Y DE MATERIALES TRENZABLES',
  'RECOLECCION, TRATAMIENTO Y ELIMINACION DE DESECHOS, RECUPERACION DE MATERIALES',
  'REPARACION E INSTALACION DE LA MAQUINARIA Y  EQUIPO',
  'SEGUROS, REASEGUROS Y FONDOS DE PENSIONES, EXCEPTO LOS PLANES DE SEGURIDAD SOCIAL DE AFILIACION OBLIGATORIA',
  'SERVICIO DE ALIMENTO Y BEBIDA',
  'SERVICIOS FINANCIEROS, EXCEPTO SEGUROS Y FONDOS DE PENSIONES',
  'SILVICULTURA Y EXTRACCION DE MADERA',
  'SUMINISTRO DE ELECTRICIDAD, GAS, VAPOR Y AIRE ACONDICIONADO',
  'TELECOMUNICACIONES',
  'TRANSPORTE POR VIA ACUATICA',
  'TRANSPORTE POR VIA AEREA',
  'TRANSPORTE POR VIA TERRESTRE; TRANSPORTE POR TUBERIAS',
];

export const currency = [
  'AFGHANI',
  'ALGERIAN DINAR',
  'ANDORRAN PESETA',
  'ARGENTINE PESO',
  'ARMENIAN DRAM',
  'ARUBAN GUILDER',
  'AUSTRALIAN DOLLAR',
  'AZERBAIJANIAN MANAT',
  'BAHAMIAN DOLLAR',
  'BAHRAINI DINAR',
  'BALBOA',
  'BARBADOS DOLLAR',
  'BATH',
  'BELARUSSIAN RUBLE',
  'BELGIAN FRANC',
  'BELIZE DOLLAR',
  'BERMUDIAN DOLLAR',
  'BOLÍVAR SOBERANO',
  'BOLIVIANO',
  'BRAZILIAN REAL',
  'BRENEI DOLLAR',
  'BURUNDI FRANC',
  'CANADIAN DOLLAR',
  'CAPE VERDE ESCUDO',
  'CAYMAN ISLANDS DOLLAR',
  'CEDI',
  'CFA FRANC BCEAO',
  'CFA FRANC BEAC',
  'CFP FRANC',
  'CHILEAN PESO',
  'COLOMBIAN PESO',
  'COMORO FRANC',
  'CORDOBA ORO',
  'COSTA RICA COLON',
  'CUBAN PESO',
  'CYPRUS POUND',
  'CZECH KORUNA',
  'DALASI',
  'DANISH KRONE',
  'DENAR',
  'DEUTSCHE MARK',
  'DINAR',
  'DJIBOUTI FRANC',
  'DOBRA',
  'DOMINICAN PESO',
  'DONG',
  'DRACHMA',
  'EAST CARIBBEAN DOLLAR',
  'EGYPTIAN POUND',
  'EL SALVADOR COLON',
  'ETHIOPIAN BIRR',
  'EURO',
  'EUROPEAN COMPOSITE UNIT EURCO',
  'EUROPEAN CURRENCY UNIT',
  'EUROPEAN MONETARY UNIT EMU-6',
  'EUROPEAN UNIT ACCOUNT- 17',
  'EUROPEAN UNIT OF ACCOUNT-9',
  'FIJI DOLLAR',
  'FLAKLAND ISLANDS POUND',
  'FORINT',
  'FRENCH FRANC',
  'GIBRALTAR POUND',
  'GOLD',
  'GOLD FRANC SPECIAL SETTLEMENT',
  'GOURDE',
  'GUARANI',
  'GUINEA FRANC',
  'GUINEA-BISSAU PESO',
  'GUYANA DOLLAR',
  'HONG KONG DOLLAR',
  'HRYVNIA',
  'ICELAND KRONA',
  'INDIAN RUPEE',
  'IRANIAN RIAL',
  'IRAQUI DINAR',
  'IRISH POUND',
  'ITALIAN LIRA',
  'JAMAICAN DOLLAR',
  'JORDANIAN DINAR',
  'KAWAITI DINAR',
  'KENYAN SHILLING',
  'KINA',
  'KIP',
  'KROON',
  'KUNA',
  'KWACHA',
  'KWACHA',
  'KWANZA',
  'KYAT',
  'LARI',
  'LATVIAN LATS',
  'LEBANESE POUND',
  'LEK',
  'LEMPIRA',
  'LEONE',
  'LEU',
  'LEV',
  'LIBERIAN DOLLAR',
  'LIBYAN DINAR',
  'LILANGENI',
  'LITHUANIAN LITAS',
  'LOTI',
  'LUXEMBOURG FRANC',
  'MALAGASY FRANC',
  'MALAYSIA RINGGIT',
  'MALDOVAN LEU',
  'MALTESE LIRA',
  'MANAT',
  'MARKKA',
  'METICAL',
  'MEXICAN PESO',
  'MEXICAN UNIDAD DE INVERSIÓN',
  'MOROCCAN DIRHAM',
  'MURITIUS RUPEE',
  'MVDOL',
  'NAIRA',
  'NAMIBIA DOLLAR',
  'NEPALESE RUPEE',
  'NETHERLANDES ANTILLEAN GUILDER',
  'NETHERLANDS GUILDER',
  'NEW DINAR',
  'NEW KWANZA',
  'NEW TAIWAN DOLLAR',
  'NEW ZAIRE',
  'NEW ZEALAND DOLLAR',
  'NGULTRUM',
  'NORWEGIAN KRONE',
  'NUEVO SOL',
  'OUGUIYA',
  'PA´ANCA',
  'PAKISTAN RUPEE',
  'PALLADIUM',
  'PATACA',
  'PESO URUGUAYO',
  'PHILIPPINE PESO',
  'PLATINUM',
  'PORTUGUESE ESCUDO',
  'POUND STERLING',
  'PULA',
  'QATARY RIAL',
  'QUETZAL',
  'RAND',
  'RIAL OMANI',
  'RIEL',
  'RUFIYAA',
  'RUPIAH',
  'RUSSIAN RUBLE',
  'RWANDA FRANC',
  'SAUDI RIYAL',
  'SCHILLING',
  'SDR INT´L MONETERY FUND',
  'SEYCHELLES RUPEE',
  'SHEKEL',
  'SILVER',
  'SINGAPORE DOLLAR',
  'SLOVAK KORUNA',
  'SOLOMON ISLANDS DOLLAR',
  'SOM',
  'SOMALI SHILLING',
  'SPANISH PESETA',
  'SRI LANKA RUPEE',
  'ST. HELENA POUND',
  'SUCRE',
  'SUDANESE DINAR',
  'SURINAM GUILDER',
  'SWEDISH KRONA',
  'SWISS FRANC',
  'SYRIAN POUND',
  'TAJIK RUBLE',
  'TAKA',
  'TALA',
  'TANZANIAN SHILLING',
  'TENGE',
  'TIMOR ESCUDO',
  'TOLAR',
  'TRANSACCIÓN WITHOUT CURRENCY',
  'TRINIDAD AND TOBAGO DOLLAR',
  'TUGRIK',
  'TUNISIAN DINAR',
  'TURKISH LIRA',
  'UAE DIRHAN',
  'UGANDA SHILLING',
  'UIC FRANC SPECIAL SETTLEMENT',
  'UNIDAD DE VALOR CONSTANTE (UVC)',
  'UNIDADES DE FOMENTO',
  'US DOLLAR',
  'US DOLLAR, NEXT DAY FUNDS',
  'UZBEKISTAN SUM',
  'VATU',
  'WON',
  'YEMINI RIAL',
  'YEN',
  'YUAN RENMINBI',
  'ZIMBABWE DOLLAR',
  'ZLOTY',
];

export const relation = [
  'ACCIONISTA',
  'BENEFICIARIO DE LOS FONDOS',
  'CLIENTE',
  'COMISARIO',
  'FAMILIAR',
  'FIRMA AUTORIZADA EN LA CUENTA ',
  'ORIGINANTE Y/O CAUSANTE DE LOS FONDOS',
  'OTRO',
  'PROVEEDOR',
  'REPRESENTANTE LEGAL',
];

export const document = ['E-', 'G-', 'I-', 'J-', 'P-', 'R-', 'V-'];

export const pasCi = ['E', 'P', 'V'];

export const specialCategory = [
  'ABOGADOS, CONTADORES PÚBLICOS Y OTROS PROFESIONALES INDEPENDIENTES',
  'ASOCIACIONES CIVILES SIN FINES DE LUCRO O FUNDACIONES U ORGANISMOS NO GUBERNAMENTALES (ONG´S)',
  'CASAS DE CAMBIO NACIONALES O INTERNACIONALES DOMICILIADAS O NO EN EL PAÍS',
  'CASAS DE EMPEÑO ',
  'CASINO, SALAS DE JUEGO, ENVITE Y AZAR ',
  'COMERCIALIZADORAS Y ARRENDADORAS DE VEHÍCULOS AUTOMOTORES, EMBARCACIONES Y AERONAVES.',
  'COMERCIALIZADORES DE ANTIGUEDADES, JOYAS, METALES Y PIEDRAS PRECIOSAS, MONEDAS, OBJETO DE ARTE Y SELLOS POSTALES',
  'COMERCIALIZADORES DE ARMAS, EXPLOSIVOS Y MUNICIONES ',
  'EMPRESAS DEDICADAS A LA TRANSFERENCIA O ENVÍO DE FONDOS O REMESA',
  'INVERSIONISTAS Y AGENCIAS DE BIENES RAÍCES',
  'OPERADORES CAMBIARIOS FRONTERIZOS ',
  'PERSONAS EXPUESTAS POLÍTICAMENTE (PEP), INCUYENDO A FAMILIARES CERCANOS, ASOCIADOS Y ESTRECHO COLABORADORES DE DICHA PERSONAS',
  'PERSONAS JURÍDICAS CONSTITUIDAS Y ESTABLECIDAS EN PAÍSES, ESTADOS O JURISDICCIÓN QUE POSEAN UN SISTEMA FISCAL DIFERENCIADO ENTRE RESIDENTES Y NACIONALES, ESTRICTO SECRETO BANCARIO, CARENCIA DE TRATADOS INTERNACIONALES EN LA MATERIA.',
  'PERSONAS NATURALES  O JURÍDICAS DEDICADAS HABITUALMENTE A LA COMERCIALIZACIÓN DIRECTA O INDIRECTA DE MONEDAS VIRTUALES',
  'PERSONAS NATURALES O JURÍDICAS QUE SE DEDIQUEN REGULARMENTE O HABITUALMENTE AL OTORGAMIENTO DE CRÉDITOS O A EFECTUAR DESCUENTOS O INVERSIONES CON SUS PROPIOS FONDOS',
];
